// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import type { PropsWithChildren } from 'react';
import React from 'react';
import { styled } from '@compiled/react';

import { SpotlightTarget } from '@atlaskit/onboarding';
import { componentWithFG } from '@atlaskit/platform-feature-flags-react';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';
import { LoadableAfterPaint } from '@confluence/loadable';

export { useConfluenceStandardToPremiumExperiment } from './useConfluenceStandardToPremiumExperiment.tsx';
export { useConfluenceStandardToPremiumPUBTouchpoint } from './useConfluenceStandardToPremiumPUBTouchpoint.tsx';
export { StandardToPremiumModalMountComponent } from './StandardToPremiumModalMountComponent.tsx';

const RemovedSpotlightTarget = componentWithFG(
	'remove_unused_spotlight_targets',
	({ children }: PropsWithChildren<{}>) => <>{children}</>,
	({ name, children }: { name: string } & PropsWithChildren<{}>) => (
		<SpotlightTarget name={name}>{children}</SpotlightTarget>
	),
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	display: 'none',
	'@media (min-width: 680px)': {
		display: 'initial',
	},
});

const EditionAwarenessUpsellLoadable = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EditionAwarenessUpsell" */ './EditionAwarenessUpsell.tsx'
			)
		).EditionAwarenessUpsell,
});

export const EditionAwarenessUpsellExperiment = withTransparentErrorBoundary({
	attribution: Attribution.GROWTH_LUNA,
})(({ navVersion }: { navVersion: 'nav3' | 'nav4' }) => {
	return (
		<RemovedSpotlightTarget name="edition-awareness">
			<Container>
				<EditionAwarenessUpsellLoadable navVersion={navVersion} />
			</Container>
		</RemovedSpotlightTarget>
	);
});
